/* eslint-disable
 */
import isEmpty from 'lodash/isEmpty';
import assign from 'lodash/assign';
import noop from 'lodash/noop';
import get from 'lodash/get';

export default signupCtrl;

/** @ngInject */
function signupCtrl(AlertManager, $scope, $location, User, $stateParams, DeviceChecker, RecaptchaKey,
                    MobilePhone, gaEventsService, CommonRegex, ErrorCatcher) {
  $scope.newUser = {};
  $scope.captcha = {
      key: RecaptchaKey[$location.host()]
  };
  $scope.signupForm = {
    form1: {
      $invalid: false,
      $setSubmitted: noop
    } // Need to do it due to weird behavior
  };
  $scope.isSignup = false;
  $scope.signedUp = false;
  $scope.signupError = {isError: false, code: ''};
  $scope.gaEventsService = gaEventsService;

  $scope.source = $stateParams.source;
  $scope.redirectTo = $stateParams.redirectTo;
  $scope.fromCommunity = $stateParams.source === 'communaute';

  $scope.isMobile = DeviceChecker.isMobile;
  $scope.phoneRegex = MobilePhone.phoneRegex.all;
  $scope.nameRegex = CommonRegex.fullname;

  if ($stateParams.parrainage) {
      localStorage.sponsorId = $stateParams.parrainage
  }
  if ($stateParams.promo) {
      localStorage.promoId = $stateParams.promo.toUpperCase()
  }

  $scope.updateMobilePhone = phoneNumber => {
      $scope.newUser.phone = !isEmpty(phoneNumber) ? MobilePhone.formatPhoneToPlus33(phoneNumber) : undefined;
  };

  $scope.signUp = function (newUser) {
    const userForm = assign({}, newUser, {
      utm_source: localStorage.utm_source,
      utm_medium: localStorage.utm_medium,
      utm_campaign: localStorage.utm_campaign
    });
    $scope.signupError = {isError: false, code: ''};
    $scope.signupForm.form1.$setSubmitted();
    if ($scope.signupForm.form1.$invalid) {
      return;
    }

    $scope.isSignup = true;
    const signUp$ = User.signUp(userForm).$promise;
    return signUp$
      .then(() => {
        localStorage.removeItem('utm_source');
        localStorage.removeItem('utm_medium');
        localStorage.removeItem('utm_campaign');
        if (($scope.fromCommunity === true) || ($scope.redirectTo !== undefined)) {
          localStorage.source = $stateParams.source;
          localStorage.redirectTo = $stateParams.redirectTo;
        }
        return $scope.signedUp = true;
      })
      .catch(error => {
        if (error.status === 409) {
          $scope.signupError = {isError: true, code: 'DUPLICATE_EMAIL'};
        } else if (!isEmpty(get(error, 'data.message'))) {
          $scope.signupError = {isError: true, code: 'SERVICE_MSG', message: error.data.message};
        } else {
          $scope.signupError = {isError: true, code: 'DEFAULT_MSG'};
        }
        return ErrorCatcher.catchErrorWithoutRedirect(error);
      }).finally(() => $scope.isSignup = false);
  };

  return $scope.newSignUp = function () {
    $scope.newUser = {};
    return $scope.signedUp = false;
  };
}




// WEBPACK FOOTER //
// ./src/states/signup/signup.js